export const formatTitleForURL = (title) => {
  if (title === undefined) return;
  return title
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-+/g, "-");
};
